import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const HomePage = ({ loggedIn }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (loggedIn) {
      navigate("/Services");
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="HM-container">
      <div className="HM-hero">
        <div className="HM-hero-content">
          <h1 className="HM-hero-title">
            Compassionate, Respectful, and Affordable care at HOME
          </h1>
          <button onClick={handleClick} className="HM-hero-btn">
            {loggedIn
              ? "Let's get started: Book A Service Today"
              : "Let's get started: Register today"}
          </button>
        </div>
      </div>

      <div className="HM-info-section">
        <div className="HM-info-inner">
          <div className="HM-info-left">
            <h2 className="HM-info-title">Support Where You Need It</h2>
            <div className="HM-info-text">
              <p>
                At iCare Village, we believe that aging should be met with
                dignity, care, and a strong sense of belonging. We provide
                non-medical home care services delivered by our care team – care
                aides, nursing students, and retired professionals – who are
                employed by iCare Village and supported through our
                technology-enabled care platform.
              </p>
              <p>
                Our services are designed to help older adults remain in the
                comfort of their own homes for as long as possible, while
                staying connected, supported, and independent within their
                communities.
              </p>
            </div>
          </div>

          <div className="HM-info-right">
            <div className="HM-search-card">
              <h3>Find Home Care Services Near You</h3>
              <p>Enter your postal code or city to view available services in your area.</p>
              <div className="HM-search-box">
                <input
                  className="HM-search-input"
                  type="text"
                  placeholder="e.g., Victoria, BC"
                />
                <button
                  className="HM-search-btn"
                  onClick={() => navigate("/Services")}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
